import { PostSubcategory } from '../../helpers/domain/postCategories';
import { PropertyType } from '../../helpers/domain/propertyTypes';
import { LandingPageTypes } from '../../helpers/domain/landingPages';
import { ANALYTICS_FEATURES } from '../featureTypes';

export const getComboAnalyticsFeature = ({
  postSubCategory,
  propertyType,
}: {
  postSubCategory?: PostSubcategory;
  propertyType?: PropertyType;
}): string => {
  const analyticsFeatureInfos: {
    category?: PostSubcategory;
    propertyType?: PropertyType;
    feature: string;
  }[] = [
    {
      category: PostSubcategory.Review,
      propertyType: PropertyType.Condominium,
      feature: ANALYTICS_FEATURES.LATEST_REVIEW_CONDO,
    },
    {
      category: PostSubcategory.Review,
      propertyType: PropertyType.House,
      feature: ANALYTICS_FEATURES.LATEST_REVIEW_HOME,
    },
    {
      category: PostSubcategory.Review,
      propertyType: PropertyType.Townhome,
      feature: ANALYTICS_FEATURES.LATEST_REVIEW_TOWNHOME,
    },
    {
      category: PostSubcategory.Preview,
      propertyType: PropertyType.Condominium,
      feature: ANALYTICS_FEATURES.LATEST_PREVIEW_CONDO,
    },
    {
      category: PostSubcategory.Preview,
      propertyType: PropertyType.House,
      feature: ANALYTICS_FEATURES.LATEST_PREVIEW_HOME,
    },
    {
      category: PostSubcategory.Preview,
      propertyType: PropertyType.Townhome,
      feature: ANALYTICS_FEATURES.LATEST_PREVIEW_TOWNHOME,
    },
    {
      category: PostSubcategory.PointOfView,
      propertyType: PropertyType.Condominium,
      feature: ANALYTICS_FEATURES.LATEST_POV_CONDO,
    },
    {
      category: PostSubcategory.PointOfView,
      propertyType: PropertyType.House,
      feature: ANALYTICS_FEATURES.LATEST_POV_HOME,
    },
    {
      category: PostSubcategory.PointOfView,
      propertyType: PropertyType.Townhome,
      feature: ANALYTICS_FEATURES.LATEST_POV_TOWNHOME,
    },
  ];

  return analyticsFeatureInfos.find(
    (info) =>
      info.category === postSubCategory && info.propertyType === propertyType,
  )?.feature;
};

export const getNewsGuidesDecorAnalyticsFeature = ({
  landingPageType,
}: {
  landingPageType?: LandingPageTypes;
}): string => {
  const analyticsFeatureInfos: {
    landingPageType: LandingPageTypes;
    feature: string;
  }[] = [
    {
      landingPageType: LandingPageTypes.NewsPage,
      feature: ANALYTICS_FEATURES.LATEST_NEWS,
    },
    {
      landingPageType: LandingPageTypes.GuidesPage,
      feature: ANALYTICS_FEATURES.LATEST_GUIDES,
    },
    {
      landingPageType: LandingPageTypes.DecorsPage,
      feature: ANALYTICS_FEATURES.LATEST_DECORS,
    },
  ];

  return analyticsFeatureInfos.find(
    (info) => info.landingPageType === landingPageType,
  )?.feature;
};
